import { useEffect, useState } from "react"
import { getEnrolledContents, getUserPathwaysAPI } from "./utils"
import { getUserContentSuggestions } from "./utils/contentSuggestions"

interface UseProfilePathwaysTabsProps {
    username: string;
    tab?: string;
}

interface UseProfilePathwaysTabsReturn {
    pathways: any[];
    pathwaysLoaded: boolean;
}

export const useProfilePathwaysTabs = ({ username, tab }: UseProfilePathwaysTabsProps): UseProfilePathwaysTabsReturn => {
    const [pathways, setPathways] = useState<any[]>([])
    const [pathwaysLoaded, setPathwaysLoaded] = useState<boolean>(false)

    const userPathwaysCallback = (data) => {
        setPathways(data)
        setPathwaysLoaded(true)
    }

    useEffect(() => {
        setPathwaysLoaded(false)
        switch(tab){
            case 'assigned':
                getUserContentSuggestions("pathway").then((response)=>{
                    userPathwaysCallback(response?.results?.map((pathway)=>({
                        ...pathway,
                        name:pathway?.pathway_name
                      })) ?? [])
                }).catch(()=>userPathwaysCallback([]))
                break
            case 'enrolled':
                getEnrolledContents('pathways', userPathwaysCallback)
                break
            default:
                getUserPathwaysAPI(username, userPathwaysCallback);
                break
        }
    }, [tab])

    return {
        pathways,
        pathwaysLoaded
    }
}